import { EmployeeOfProjectMemberEmployee } from 'hooks/useProjectMemberEmployee/interfaces';
import { EmployeePreview } from 'store/employee/interfaces';

export default function getEmployeeOptions(employeePreview: EmployeePreview[] | EmployeeOfProjectMemberEmployee[]) {
  return employeePreview.map((employeeItem) => ({
    value: employeeItem['@id'],
    label: `${employeeItem.firstname} ${employeeItem.lastname}`,
  }));
}
